import { useSessionStore } from '@/stores/useSessionStore'

let refreshPromise = null

async function runRefresh() {
  if (!refreshPromise) {
    refreshPromise = (async () => {
      const session = useSessionStore()
      const res = await fetch('/api/auth/refresh', {
        method: 'POST',
        credentials: 'include'
      })

      if (!res.ok) {
        session.clearSession()
        throw new Error('登录已失效，请重新登录')
      }

      const data = await res.json()
      session.setAccessToken(data.accessToken, data.expiresIn)
      return data
    })().finally(() => {
      refreshPromise = null
    })
  }
  return refreshPromise
}

export async function httpRequest(path, options = {}) {
  const {
    method = 'GET',
    body,
    headers = {},
    skipAuth = false,
    retry = true,
    responseType = 'json',
    throwOnHttpError = true
  } = options

  const session = useSessionStore()
  const finalHeaders = { ...headers }

  let finalBody = body
  if (body && typeof body === 'object' && !(body instanceof FormData) && !(body instanceof Blob)) {
    finalBody = JSON.stringify(body)
    if (!finalHeaders['Content-Type']) {
      finalHeaders['Content-Type'] = 'application/json'
    }
  }

  if (!skipAuth && session.accessToken) {
    finalHeaders.Authorization = `Bearer ${session.accessToken}`
  }

  const response = await fetch(path, {
    method,
    body: finalBody,
    headers: finalHeaders,
    credentials: 'include'
  })

  if (response.status === 401 && !skipAuth && retry) {
    await runRefresh()
    return httpRequest(path, { ...options, retry: false })
  }

  if (!response.ok && throwOnHttpError) {
    let message = `请求失败(${response.status})`
    try {
      const data = await response.json()
      message = data?.error || message
    } catch (error) {
      // ignore
    }
    const err = new Error(message)
    err.status = response.status
    throw err
  }

  if (responseType === 'blob') {
    return response.blob()
  }
  if (responseType === 'raw') {
    return response
  }
  if (responseType === 'text') {
    return response.text()
  }

  const contentType = response.headers.get('content-type') || ''
  if (contentType.includes('application/json')) {
    return response.json()
  }
  return null
}
